import { useContext, createContext, PropsWithChildren } from "react";

export const LocationContext = createContext<Location | null>(null);

export const LocationProvider = (
    props: PropsWithChildren<{ location: Location | null }>
) => {
    return (
        <LocationContext.Provider value={props.location}>
            {props.children}
        </LocationContext.Provider>
    );
};

export const useLocation = (): Location => {
    const location = useContext(LocationContext);
    if (!location) {
        throw new Error("useLocation must be used within a LocationProvider");
    }
    return location;
};
